import { WalletType } from '@/types/WalletType';
import { BANK_PARTNER_ACCOUNT_AVAILABILTY } from '@/types/WalletType';
import type { BridgeAccountPartner } from '@/modules/cashIn/constants/bridge.constants';

export function getBankPartnerStatus(
  account: WalletType,
  partnerName: BridgeAccountPartner
) {
  if (!account?.bankPartnerAccountStatusList) {
    return null;
  }

  return account.bankPartnerAccountStatusList.find(
    (item) => item.bankPartnerName === partnerName
  ) || null;
}

export function getBankPartnerStatusValue(
  account: WalletType,
  partnerName: BridgeAccountPartner
) {
  const partnerStatus = getBankPartnerStatus(account, partnerName);
  return partnerStatus?.status || BANK_PARTNER_ACCOUNT_AVAILABILTY.NOT_AVAILABLE;
}




